import { render, staticRenderFns } from "./BusinessForeignContractor.vue?vue&type=template&id=29a553d1&scoped=true&"
import script from "./BusinessForeignContractor.vue?vue&type=script&lang=ts&"
export * from "./BusinessForeignContractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a553d1",
  null
  
)

export default component.exports